import { render, staticRenderFns } from "./Mydata.vue?vue&type=template&id=9400c856&lang=html"
import script from "./Mydata.vue?vue&type=script&lang=js"
export * from "./Mydata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports